export default {

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    recipientNameContainer: {
        display: "flex",
        columnGap: "18px",
        alignItems: "end"
    },

    detailsContainer: {
        marginTop: "38px",
        marginBottom: "60px",
    },

    detailsLabel: {
        marginLeft: "8px",
        fontSize: "14px",
        fontWeight: "400",
        color: "#262626"
    },

    gapBetween: {
        marginBottom: "19px"
    },

    horizontalLine: {
        marginTop: "40px",
        marginBottom: "40px",
    },

    actionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #262626",
        borderRadius: "80px",
        padding: "6px 22px",
    },

    actionDropdownLabel: {
        marginRight: "15px"
    },

    actionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-70px",
        top: "29px",
    },

    actionButtonsContainer: {
        margin: "50px 0px 19px",
        display: "flex",
        flexDirection: "column",
        rowGap: "10px"
    },

    actionItem: {
        display: "flex",
        columnGap: "20px",
        flexDirection: "column"
    },

    requestDateContainer: {
        display: "flex",
        flexDirection: "column",
        rowGap: "10px"
    },

    wButton: {
        marginLeft: "20px"
    },

    tinStatus: {
        display: "flex",
        columnGap: "8px"
    }
}